module.exports = __webpack_public_path__ + "media/categories-photos/26-76584219.webp";